import React from 'react';
import { ExpectedVsActualConfig } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import { ToggleInput } from '@instinet-analytics/semantic-ui-components';
import { CheckboxInput } from '@instinet-analytics/semantic-ui-components';
import { NumericTextInput } from '@instinet-analytics/semantic-ui-components';

export interface FillsGraphExpectedVolumeSettingsProps {
    settings: ExpectedVsActualConfig;
    isVisible: boolean;
    toggleIsVisible: () => void;
    updateSettings: (nextSettings: ExpectedVsActualConfig) => void;
}

export default function FillsGraphExpectedVolumeSettings(
    props: FillsGraphExpectedVolumeSettingsProps
) {
    const { isVisible, toggleIsVisible, settings, updateSettings } = props;
    const { autoHideLastBucket, autoHideLastBucketThresholdPercent } = settings;

    const toggleAutoHideLastBucket = () => {
        updateSettings({
            ...settings,
            autoHideLastBucket: !autoHideLastBucket,
        });
    };

    const setAutoHideThreshold = (value: string) => {
        const i = parseInt(value);
        if (!isNaN(i)) {
            updateSettings({
                ...settings,
                autoHideLastBucketThresholdPercent: i,
            });
        }
    };

    return (
        <div className="group group-expected-vs-actual">
            <div className="group-header">
                <div className="title">Market Volume</div>
                <ToggleInput checked={isVisible} onToggle={toggleIsVisible} />
            </div>
            <div>
                <div>
                    <CheckboxInput
                        className={'auto-hide-last-bin'}
                        label="Auto hide last bin"
                        checked={autoHideLastBucket}
                        onToggle={toggleAutoHideLastBucket}
                    />
                </div>
                <div className="last-bin-hidden-threshold">
                    <div>Auto hide threshold (%)</div>
                    <NumericTextInput
                        value={autoHideLastBucketThresholdPercent}
                        onChange={setAutoHideThreshold}
                        min={5}
                        max={100}
                    />
                </div>
            </div>
        </div>
    );
}
